<div>
  <div bsModal #ratingModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Rate Inspector</h4>
        </div>
        <div class="modal-body">
          <form [formGroup]="ratingForm">
            <div class="form-group">
              <label>Rating</label>
              <select formControlName="rating" class="form-control">
                <option *ngFor="let x of [].constructor(10); index as i" [value]="i + 1">{{ i + 1 }}</option></select
              ><br />
              <label>Rating Note</label>
              <textarea
                class="form-control"
                style="height: 100px; white-space: pre-wrap"
                formControlName="ratingNote"></textarea>
            </div>
          </form>
          <br />

          <div style="text-align: right">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="save()">Rate and Complete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
